export default __webpack_public_path__ + "static/media/superwarm_v_steamer_.679f9617.jpg";